<template lang="pug">
  .page__items
    .page__item(data-id="main")
      Main
    .page__item(data-id="menu")
      Menu
    .page__item(data-id="about")
      About
    .page__item(data-id="photo-reports")
      PhotoReports
    .page__item(data-id="photo-reports-inside")
      PhotoReportsInside
    .page__item(data-id="announce")
      Announce
    .page__item(data-id="announce-inside")
      AnnounceInside
    .page__item(data-id="reviews")
      Reviews
    .page__item(data-id="tour")
      Tour
    .page__item(data-id="restaurants")
      Restaurants
    .page__item(data-id="contacts")
      Contacts
    .page__item(data-id="cart")
      Cart
    .page__item(data-id="privacy-policy")
      PrivacyPolicy
    .page__item(data-id="card-payment")
      CardPayment
    .page__item(data-id="company-details")
      CompanyDetails
    .page__item(data-id="page-404")
      Page404

</template>

<script>
  import EventBus from '@/eventBus';

  import Main from '@/views/Main';
  import Menu from '@/views/Menu';
  import About from '@/views/About';
  import PhotoReports from '@/views/PhotoReports';
  import PhotoReportsInside from '@/views/PhotoReportsInside';
  import Announce from '@/views/Announce';
  import AnnounceInside from '@/views/AnnounceInside';
  import Reviews from '@/views/Reviews';
  import Tour from '@/views/Tour';
  import Restaurants from '@/views/Restaurants';
  import Contacts from '@/views/Contacts';
  import Cart from '@/views/Cart';
  import PrivacyPolicy from '@/views/PrivacyPolicy';
  import CardPayment from '@/views/CardPayment';
  import CompanyDetails from '@/views/CompanyDetails';
  import Page404 from '@/views/Page404';

  export default {
    components: {
      Main,
      Menu,
      About,
      PhotoReports,
      PhotoReportsInside,
      Announce,
      AnnounceInside,
      Reviews,
      Tour,
      Restaurants,
      Contacts,
      Cart,
      PrivacyPolicy,
      CardPayment,
      CompanyDetails,
      Page404
    },

    // Первый заход на страницу & для роутов типа /catalog/:id
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // экземпляр компонента доступен как `vm`

        let params = vm.getParams(to);

        EventBus.$emit(params.event, params);
      })
    },

    // Навигация по ссылкам
    beforeRouteUpdate(to, from, next) {
      let params = this.getParams(to);

      EventBus.$emit(params.event, params);

      next();
    },

    methods: {
      getParams(route) {
        let path = route.path;
        let url  = route.path || '';

        let routeName = route.name || '';

        let event  = '';
        let params = {};

        if(path === '/') {
          event = 'loadMainPage';
        }
        else if(path === '/menyu') {
          event = 'loadMenuPage';
        }
        else if(path === '/o-zavedenii') {
          event = 'loadAboutPage';
        }
        else if(path === '/fotootchety') {
          event = 'loadPhotoReportsPage';
        }
        else if(path === '/anonsy') {
          event = 'loadAnnouncePage';
        }
        else if(path === '/otzyvy') {
          event = 'loadReviewsPage';
        }
        else if(path === '/3d-tur') {
          event = 'loadTourPage';
        }
        else if(path === '/nashi-zavedeniya') {
          event = 'loadRestaurantsPage';
        }
        else if(path === '/kontakty') {
          event = 'loadContactsPage';
        }
        else if(path === '/politika-konfidencialnosti') {
          event = 'loadPolicyPage';
        }
        else if(path === '/oplata-po-karte-sberbanka') {
          event = 'loadCardPaymentPage';
        }
        else if(path === '/rekvizity-kompanii') {
          event = 'loadCompanyDetailsPage';
        }
        else {
          event = 'load404Page';
        }

        // Name

        if(routeName === 'MenuInside') {
          event         = 'loadMenuPageInside';
          params.params = route.params || {};
        }

        if(routeName === 'PhotoReportsInside') {
          event         = 'loadPhotoReportsInsidePage';
          params.params = route.params || {};
        }

        if(routeName === 'AnnounceInside') {
          event         = 'loadAnnounceInsidePage';
          params.params = route.params || {};
        }

        if(routeName === 'Cart' || routeName === 'CartStep') {
          event         = 'loadCartPage';
          params.params = route.params || {};
        } else {
          EventBus.$emit('resetFirstReq');
        }

        params.event = event || '';
        params.url   = url;

        return params;
      }
    }
  }
</script>
